export default __webpack_public_path__ + "static/media/worm.b21aa089.png";